/**
 * The root element that contains all potentially targeted elements for this
 * module.
 *
 * @type {HTMLElement}
 */
const $root = document.querySelector('.property-index--wishlist');

/**
 * The wrapping container for the viewport.
 *
 * @type {HTMLElement}
 */
const $container = document.querySelector('.site-container');

/**
 * A list of elements that are needed for this module.
 *
 * @type {{
 *	   list: HTMLElement,
 *	   notFound: HTMLElement,
 * }}
 */
const $elements = {};

/**
 * The cookie name for the saved property data.
 *
 * @type {string}
 */
const WISHLIST_KEY = 'pickard_properties_wishlist_ids';

/**
 * The target URL for any REST endpoints.
 *
 * @type {string}
 */
const REST_URL = window.ajaxSettings?.rest?.url || false;

/**
 * Sets up the $elements object.
 *
 * Called once the $root element has been confirmed to exist.
 *
 * @return void
 */
function setupElements() {
	$elements.titleWishlistCount = $root.querySelector('.property-index__titles--wishlist-count');
	$elements.titlePropertyCount = $root.querySelector('.property-index__titles--count');
	$elements.titleCountLabel = $root.querySelector('.property-index__titles--text');
	$elements.list = $root.querySelector('.property-index__index');
	$elements.notFound = $root.querySelector('.property-index__no-results');
}

/**
 * Grab the current wishlisted property IDs from the user's local storage.
 *
 * @return int[]
 */
function getWishlistValues() {
	let wishlist = localStorage.getItem(WISHLIST_KEY);

	if (! wishlist) {
		return [];
	}

	// MR: Not huge on this but it works for now.
	try {
		return JSON.parse(wishlist);
	} catch {
		return [];
	}
}

/**
 * Update the saved properties heading with the total number of properties in the list.
 *
 * @param {int} total
 * @return void
 */
function updateWishlistTitleCount(total) {
	$elements.titlePropertyCount.textContent = String(total);
	$elements.titleCountLabel.textContent = total > 1 ? 'properties' : 'property';
	$elements.titleWishlistCount.style.display = 'block';
}

/**
 * Attempts to post to the REST API for wishlisted property card markup.
 */
async function queryWishlistMarkup(ids) {
	const headers = new Headers({
		'Content-Type': 'application/json',
	});

	const response = await fetch(`${REST_URL}/property-search/wishlist-markup`, {
		method: 'POST',
		body: JSON.stringify({ ids }),
		headers,
	});

	if (! response.ok) {
		throw new Error('Unable to load markup');
	}

	const markup = await response.json();

	return markup;
}

/**
 * Constructor.
 *
 * @return void
 */
export async function hydrateWishlistCards() {
	if ( ! $root ) {
		return;
	}

	$container.classList.add('site-container--loading');

	setupElements();

	const ids = getWishlistValues();

	if (! ids) {
		return;
	}

	try {
		const markup = await queryWishlistMarkup(ids);

		$elements.list.innerHTML = markup;

		updateWishlistTitleCount(ids.length);
	} catch {
		$elements.notFound.style.display = 'block';
	} finally {
		$container.classList.remove('site-container--loading');
	}
}

